import type { FaireProductEntity } from "../../entity_types/product";

export const p_3hytmvjnt9: FaireProductEntity = {
  token: "p_3hytmvjnt9",
  type: "product",
  name: "BIG STEP - Satin Split Toe Ballet Flat, Stitch Details",
  brandToken: "b_mz3xxxsvnf",
  brandName: "Lemonade Shoes",
  imageUrl:
    "https://cdn.faire.com/fastly/9e8cec27a7c59787b50b58ce7516c2f48fcfb566c283415197855ba2231945c0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/625b21e7958f70336250043874239e8316a2604729ed519a6256a572b842da79.jpeg",
    "https://cdn.faire.com/fastly/a3d180a6b9b95c340ea2fcbe380571477b7b3215265c5fa3f1dfe424c5886564.jpeg",
    "https://cdn.faire.com/fastly/ce17ba57e620445311a1ed269ad23b5130af086039df53d86507af750f7e24fa.jpeg",
    "https://cdn.faire.com/fastly/4fca201c8ac52dbb82691113c6f377d81190e5db98b27371a1e68694bd832a95.jpeg",
    "https://cdn.faire.com/fastly/348854f761daf72d2521b7c678ef92846459c860bc37a523ad06ddf7f3cf2a86.jpeg",
    "https://cdn.faire.com/fastly/60d0f48ae74401e67c046e0dc6dc917b22be5803fe17612737cddd7ba01148b1.jpeg",
    "https://cdn.faire.com/fastly/9ea16cd2242678ec9e60b8a87b651f76e084f5e12b986473c9a4ec502f43535c.jpeg",
    "https://cdn.faire.com/fastly/092955bacbe850165996ac1c3b1ab6a30f292e405bd9dc8612c7a743995e0aff.jpeg",
    "https://cdn.faire.com/fastly/cb42595a45f9df69e5bcaa37acb7bf8cf245777918f6333b199a514e0505e800.jpeg",
  ],
  priceDollars: 13,
  description:
    "Soft, minimal, and a little unexpected. This satin flat features a delicate split-toe design with a smooth, flexible finish that molds comfortably to your foot. The adjustable tie detail adds a subtle feminine touch while keeping the look clean and modern. Easy, versatile, and quietly statement-making. Please note: slight color shift may occur depending on lighting.\n\nOOTD\nPair with straight-leg jeans and a fitted tee for an effortless everyday look, or style with a slip skirt and lightweight cardigan for something softer. Add simple jewelry to keep the vibe clean and elevated.",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:49:18.386Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
